module.exports = __webpack_public_path__ + "static/about-figures-3-60eea1bf4f0233ba263bef9e39b29d48.png";